import moment from "moment"


export const toDate = () => {
    return moment().add(2, 'year').endOf('year')
} 
